import { EventBus, TOOL_USE_EVENT } from '../common/EventBus'

export default class ToolButton {
  constructor (element) {
    element.addEventListener('click', () => {
      EventBus.$emit(TOOL_USE_EVENT, element.href, element.dataset.toolType)
    })
  }
}
